import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerInput: {
        marginHorizontal: 12,
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: 16,
    },
    containerInputPrice: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    inputPrice: {
        width: 120,
        marginLeft: 6,
        height: 40,
        borderRadius: 5,
        paddingVertical: 10,
        paddingHorizontal: 10,
        marginHorizontal: 0,
        marginBottom: 5,
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.textPrimary,
        backgroundColor: theme.colors.inputBackground,
    },
    label: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingVertical: 5,
        paddingHorizontal: 15,
        //marginBottom: 'auto',
    },
    text: {
        fontSize: 22,
        fontWeight: 'normal',
        paddingBottom: 4,
        color: theme.colors.textPrimary,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingTop: 0,
        paddingLeft: 110,
        paddingRight: 15,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '50%',
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        marginLeft: 110,
        marginRight: 15,
        marginTop: 5,
        marginBottom: 10,
    },
    input: {
        flex: 1,
        color: theme.colors.textPrimary,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
})

export default styles
